import { Component, OnInit } from '@angular/core';
import { SrcPath } from'src/app/constants/srcPath';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { isPresent } from 'src/app/utils/utils';
import { KEYS } from'src/app/constants/keys'; 
import { CommonService } from 'src/app/services/common-service/common.service';
import { BreadcrumbComponent } from 'src/app/components/breadcrumb/breadcrumb.component'; 
import { DashboardNavbarComponent } from 'src/app/components/dashboard-navbar/dashboard-navbar.component';
declare var $ :any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports:[RouterModule,BreadcrumbComponent,DashboardNavbarComponent]
})
export class DashboardComponent implements OnInit {
  //searchText:any;
  menuListData: any;
  menuIcon = SrcPath.menuIconPath;
  customerId: any;
  customerIdFlag: boolean = false
  isSuperaDmin: boolean  = false;
  showIcon: boolean = false;;
  adminSelectedTopMenu="Customers";

  constructor(private route: ActivatedRoute,private router: Router,private commonService: CommonService ) { }

  ngOnInit(): void {
    
    this.isSuperAdmin();
    this.adminSelectedTopMenu=this.commonService.getAdminSelectedTopMenu();
    this.adminSelectedTopMenu=(this.adminSelectedTopMenu ==''?"Customers": this.adminSelectedTopMenu);
    // this.loadMenudata();
    this.route.queryParams.subscribe(params => {
      this.customerId = params['customerId'];
      if (this.customerId > 0) {
        this.customerIdFlag = true;
        // this.loadMenudata();
      } else {

      }
    });

  }
  isSuperAdmin() {
    let isCredData =  isPresent(JSON.parse(sessionStorage.getItem(KEYS.user_credential)!));
    if(isCredData){
      let credData = JSON.parse(sessionStorage.getItem(KEYS.user_credential)!);
      if(credData.user_Type == 1||credData.user_Type == 3){
          this.isSuperaDmin = true;
      }else{
        this.isSuperaDmin = false;
      }
    }
  }
/*
  loadMenudata() {
    $('.iconBlock').css('display','flex');
    if(this.isSuperaDmin == true){
    //if(this.customerIdFlag == true && this.isSuperaDmin == true){
      this.showIcon = true;
    }else{
      this.showIcon = false;
    }
    this.menuListData = [
      {

        "gstibo_menu_name": "Customers",
        "gstibo_menu_style": "back02",
        "gstibo_icon": "profile"
      },
      {

        "gstibo_menu_name": "Dashboard",
        "gstibo_menu_style": "back02",
        "gstibo_icon": "profile"
      },
      {

        "gstibo_menu_name": "Modules",
        "gstibo_menu_style": "back02",
        "gstibo_icon": "manager"
      },
      {

        "gstibo_menu_name": "Menus",
        "gstibo_menu_style": "back02",
        "gstibo_icon": "manager"
      },
      {

        "gstibo_menu_name": "All Pages",
        "gstibo_menu_style": "back02",
        "gstibo_icon": "manager"

      },
     
      {
        "gstibo_menu_name": "Reports",
        "gstibo_menu_style": "back02",
        "gstibo_icon": "profile"
      }
    ]
  }
  viewDetailFromMenu(data){
    this.commonService.setAdminSelectedTopMenu(data.gstibo_menu_name);
    this.adminSelectedTopMenu=data.gstibo_menu_name;
    if(data.gstibo_menu_name=="All Pages"){      
      const path = RoutePath.pages;
      this.router.navigate([path]);
    } else if(data.gstibo_menu_name=="Menus"){
      const path = RoutePath.menu;
      this.router.navigate([path]);
    } else if(data.gstibo_menu_name=="Modules"){
      const path = RoutePath.modules;
      this.router.navigate([path]);
    } else if(data.gstibo_menu_name=="Dashboard"){
      const path = RoutePath.dashboard;
      this.router.navigate([path]);
    } else if(data.gstibo_menu_name=="Customers"){
      const path = RoutePath.customer;
      this.router.navigate([path]);
    } else if(data.gstibo_menu_name=="Reports"){
      const path = RoutePath.adminDashboard;
      this.router.navigate([path]);
    }
  
  }
  */
}
